<!-- LazyImage.vue -->
<template>
    <img v-if="isIntersecting" :src="src" :alt="alt" :class="customClass" />
    <img v-else :src="loading" alt="Loading..." :class="customClass" />
    <!-- <img src="../assets/load.png"/> -->
  </template>
  
  <script>
  export default {
    name: 'LazyImage',
    props: {
      src: {
        type: String,
        required: true,
      },
      loading: {
        type: String,
        default: require('@/assets/load.png'), // 默认加载图
      },
      customClass: {
        type: String,
        default:  '',
      },
      alt: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        isIntersecting: false,
      };
    },
    mounted() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isIntersecting = true;
            observer.unobserve(entry.target); // 只加载一次
          }
        });
      });
      observer.observe(this.$el);
    },
  };
  </script>
  